import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ background: _ctx.info.color }),
    class: "skillBox flex justify-center items-center font-semibold"
  }, _toDisplayString(_ctx.info.name), 5))
}